import React from 'react';
import { ConfirmModal } from '../../../../../../components';

export const DragAssignmentConfirmModal = ({ open, onCancel, onConfirm, title, message }) => {
    return (
        <ConfirmModal title={title} open={open} onCancel={onCancel} onContinue={onConfirm}>
            {message}
        </ConfirmModal>
    );
};
